import { Box, Typography } from '@mui/material';
import { Entity } from 'ui-component/icons';
import { useState } from 'react';
import { EntityPopover } from './EntityPopover';

export const RenderEntity = ({ value }: { value: { displayName: string; id: string } }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    if (value) {
        const { displayName, id } = value;

        const handleMouseLeave = () => {
            setTimeout(() => {
                setAnchorEl(null);
            }, 100);
        };

        const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        };

        const open = Boolean(anchorEl);

        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '20px',
                    width: '100%',
                    position: 'relative'
                }}
            >
                <Typography sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>
                    {displayName}
                </Typography>
                <Box
                    data-testid="entity-hover-box"
                    data-entity-key={`entity-${displayName}-${id}`}
                    onMouseEnter={handleMouseEnter}
                    sx={{ display: 'flex', alignItems: 'center' }}
                >
                    <Entity sx={{ width: '1rem', height: '1rem', cursor: 'pointer' }} />
                </Box>
                <EntityPopover open={open} anchorEl={anchorEl} onClose={handleMouseLeave} entityId={id} />
            </Box>
        );
    }
    return <></>;
};
